// extracted by mini-css-extract-plugin
export default {"footermain":"Footer_footermain__tFPqz","footeritems":"Footer_footeritems__dB2pK","footer":"Footer_footer__vZ5GG"};